<script lang="ts" setup>
	import { useDebounceFn } from '@vueuse/core'
	withDefaults(
		defineProps<{
			value?: string
			placeholder?: string
			inputClass?: ClassContext
			iconHeight?: number
			iconWidth?: number
			useCustomClass?: boolean
		}>(),
		{
			placeholder: 'search',
			useCustomClass: true
		}
	)

	const emits = defineEmits<{
		(arg: 'update:value', param: string): void
		(arg: 'change', param: string): void
	}>()
	const monitorInput = useDebounceFn((payload: Event) => {
		const input = payload.target as HTMLInputElement
		const inputValue = input.value.trim()

		emits('update:value', inputValue)
		emits('change', inputValue)
	}, 1000)
</script>

<template>
	<div class="relative flex items-center gap-x-3" :class="[useCustomClass ? ' border  rounded-lg px-5' : '']">
		<tools-icon dir="line" icon="search" :height="iconHeight" :width="iconWidth" />
		<input
			class="custom-input w-full !border-none placeholder:capitalize placeholder-gray-400 text-gray-600 text-sm"
			:class="inputClass"
			type="search"
			:value="value"
			:placeholder="placeholder"
			@input="monitorInput"
		/>
	</div>
</template>
